module.exports = __webpack_public_path__ + "img/message-image.66e8a035.svg";